import { useState } from "react";
import { BarChart3, ChevronRight, CircleDollarSign, Plus, TrendingUp, Wallet } from "lucide-react";
import { Periods, ProfitChart, Stat, StatusPill } from "../components/common";
import { signedUsd, usd, dateTime } from "../lib/api";

export default function Overview({ data, user, go }) {
  const [period, setPeriod] = useState("daily");
  const accounts = data?.accounts || [];
  const series = data?.series?.[period] || [];
  const total = series.length ? series[series.length - 1].cumulative : 0;
  return (
    <>
      <div className="welcome">
        <div>
          <p className="eyebrow">{new Date().toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long" }).toUpperCase()}</p>
          <h2>Selamat datang, {user.alias || user.name?.split(" ")[0]}<span> ✦</span></h2>
          <p className="muted">Ringkasan performa nyata dari akun trading yang tersinkron.</p>
        </div>
        <button className="primary" onClick={() => go("accounts")} data-testid="connect-account-button"><Plus size={17} /> Hubungkan akun</button>
      </div>
      <div className="stats-grid">
        <Stat testId="stat-equity" label="Total equity" value={usd(data?.equity)} hint={`Balance ${usd(data?.balance)}`} icon={Wallet} />
        <Stat testId="stat-today" label="Profit hari ini" value={signedUsd(data?.today || 0)} hint={`${data?.trades || 0} deal tercatat`} positive={(data?.today || 0) >= 0} icon={TrendingUp} />
        <Stat testId="stat-month" label="Profit bulan ini" value={signedUsd(data?.month || 0)} hint={`Win rate ${data?.win_rate || 0}%`} positive={(data?.month || 0) >= 0} icon={BarChart3} />
        <Stat testId="stat-sharing" label="Profit sharing" value={usd(data?.share_due)} hint="20% dari profit bulan ini" icon={CircleDollarSign} />
      </div>
      <div className="dashboard-grid">
        <section className="panel chart-panel">
          <div className="panel-head">
            <div><p className="eyebrow">NET PERFORMANCE</p><h3>Kurva profit & loss</h3></div>
            <Periods value={period} onChange={setPeriod} prefix="chart-period" />
          </div>
          <div className={total >= 0 ? "big-number" : "big-number neg"} data-testid="overview-period-total">{signedUsd(total)}</div>
          <ProfitChart data={series} color={total >= 0 ? "#27d69b" : "#f16d6d"} />
        </section>
        <section className="panel sync-panel">
          <div className="panel-head">
            <div><p className="eyebrow">CONNECTED SOURCES</p><h3>Akun trading</h3></div>
            <button className="icon-btn" onClick={() => go("accounts")} data-testid="manage-accounts-button"><ChevronRight size={18} /></button>
          </div>
          {accounts.length === 0 && <p className="muted pad-y" data-testid="overview-no-accounts">Belum ada akun terhubung.</p>}
          {accounts.slice(0, 4).map((a) => (
            <div className="account-row" key={a.id}>
              <div className={`platform-icon ${a.platform === "cTrader" ? "ct" : "mt"}`}>{a.platform === "cTrader" ? "cT" : a.platform}</div>
              <div><b>{a.platform} · {a.broker}</b><small>{a.login} · Sync {dateTime(a.last_sync)}</small></div>
              <StatusPill status={a.status} />
            </div>
          ))}
          <button className="outline full" onClick={() => go("accounts")} data-testid="add-trading-account-button"><Plus size={16} /> Tambah akun trading</button>
        </section>
      </div>
    </>
  );
}
